import { JarvisAuthProvider } from '@jarvis/web-http'
import { OnboardingDirectorClient } from '../clients/onboarding-director-api/onboarding-director-client'
import { Stack } from '../clients/web-client'
import { SessionPayload } from '../interface/controllerInterface'
import { OnboardingDirectorClientMock } from '../mock/clients/onboarding-director-client-mock'
import { PLSClient } from '../clients/pls-client-api/pls-client'
import { Logger } from './helperMethods'

export const createSession = async (
  stack: Stack | string,
  authProvider: JarvisAuthProvider,
  sessionPayload: SessionPayload
) => {
  const client = stack
    ? new OnboardingDirectorClient(stack, authProvider)
    : new OnboardingDirectorClientMock(stack, authProvider)
  const response = await client.createSession(sessionPayload)
  return response
}

/**
 * Retrieves information about a specific printer model using the provided authentication provider.
 *
 * @param authProvider - An instance of `JarvisAuthProvider` used to authenticate API requests.
 * @param printerModel - The model identifier of the printer for which information is requested.
 * @returns A promise that resolves with the printer data retrieved from the API.
 */
export const getPrinterInfo = async (
  authProvider: JarvisAuthProvider,
  printerModel: string
) => {
  const baseUrl = process.env['REACT_APP_SMART_SHARED_SERVICES_API_BASE_URL']
  if (!baseUrl) {
    throw new Error('Base URL is not defined in environment variables.')
  }
  const client = new PLSClient(baseUrl, authProvider)
  const response = await client.getPrinterData(printerModel)
  Logger.log('Received response from PLSClient:', response)
  return response
}
